module.exports = __webpack_public_path__ + "img/2.507b8167.webp";